












import Vue from 'vue'

import axios from 'axios'
import HomePage from './template'

export default Vue.extend({
  name: 'ComponentName',
  data() {
    return {
      model: {},
      show: false,
      data: HomePage,
    }
  },
  methods: {
    async getTemplate() {
      this.show = false
      const { data } = await axios.get(
        '/img/Coal_fired_power_plant_diagram.svg'
      )
      this.data.template = `<div>${data}</div>`
      this.show = true
    },
  },

  created() {
    this.getTemplate()
  },
})
